import React from 'react';
import Reflux from 'reflux';
import './Footer.css';
class Footer extends Reflux.Component {
    render () {
        return (
          <footer>
            <div className='footer'>
              <div className='container-gral'>
                <a className='brandWhite'>
                  <img src='/images/brandWhite.svg' />
                </a>
                <a href='https://grava.digital/'>
                  <img src='/images/gravaFooter.svg' />
                </a>
                <div className='copyright'>
                  <span className='left-align'>2018 - Desarrollado por grava.digital</span>
                  <div className='right-align'>
                    <a href='/terms&conditions'>Términos y Condiciones - Políticas de Privacidad</a>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        );
    }
}
export default Footer;



// WEBPACK FOOTER //
// ./src/sections/Footer.js